export const messages = {
  en: {
    contractChangeAuditHistoryOrders: {
      title: 'Change Processed Orders',
      contractCode: 'Contract Number',
      contractName: 'Contract Name',
      contractTypeName: 'Contract Type',
      stateName: 'Contract Status',
      createTime: 'Creation Time',
      operation: 'Operation',
      view: 'View',
      fetchError: 'Failed to fetch contract change history'
    }
  },
  zh: {
    contractChangeAuditHistoryOrders: {
      title: '变更已办单',
      contractCode: '合同编号',
      contractName: '合同名称',
      contractTypeName: '合同类型',
      stateName: '合同状态',
      createTime: '创建时间',
      operation: '操作',
      view: '查看',
      fetchError: '获取合同变更历史失败'
    }
  }
}